module.exports = __webpack_public_path__ + "img/bg-new.3079da6a.png";